import { render, staticRenderFns } from "./RadioFilter.vue?vue&type=template&id=3b97c282&"
import script from "./RadioFilter.vue?vue&type=script&lang=js&"
export * from "./RadioFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports